var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('apiKeys'),_vm._v(" "),_c('setCurrency'),_vm._v(" "),_c('setCallbacks'),_vm._v(" "),_c('setRedirection'),_vm._v(" "),_c('setLogo'),_vm._v(" "),_c('setRecords')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-257f625d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalSettings/globalSettings.vue
// module id = 410
// module chunks = 0